export default __webpack_public_path__ + "media/assets/img/img_icon_lead-7c13d173708db2030de80e8346015ca8.svg";